(function () {
  "use strict";

  var sfImporter = {};
  const gatherContentOptions = {
    method: "GET",
    headers: {
      Accept: "application/vnd.gathercontent.v2+json",
      Authorization:
        "Basic ZGlnaXRhbEBoZWFsdGgucWxkLmdvdi5hdTo2N2M0MzE0NC01MWExLTQ5YmItOGUyNi1lYTE3OTYxOGUwNDQ=",
    },
  };
  var dsServiceLocationData;
  var dsServiceData;
  var dsFacilityData;
  var updatedBy;

  // Field structure for service locations - each value for the keys will get assigned a UUID if one matches from the template
  var fieldStructure = {
    name: "",
    web_path: "",
    services_content: "", // this is part of the content field from gather content
    service_description: "",
    how_to_access_this_service: "", // this is part of the content field from gather content
    content: "", // uses the two fields above
    description: "",
    status: "",
    rsd_service_id: "",
    service_id: "",
    facility_id: "",
    facility_level: "",
    contact_label: "",
    contact_label_type: "",
    email_address: "",
    fax_number: "",
    primary_phone_number: "",
    opening_hours: "",
    building: "",
    location_details: "",
    physical_address_postcode: "",
    physical_address_street: "",
    physical_address_suburb: "",
    street_address: "",
    suburb: "",
    postcode: "",
    latitude: "",
    longitude: "",
    secondary_contact_label: "",
    secondary_phone_number: "",
    updatedBy: "",
    updatedDate: "",
  };

  /**
   * Init the Service Finder importer.
   *
   * @memberof module:serviceImporter
   */
  sfImporter.init = function () {
    var $loader = $(".qld__sf_admin_importer");
    var $importForm = $("#sf-importer__form");
    var $importBtn = $("#sf-importer__import-btn");
    var $projectIdInput = $("#sf-importer__project-id");
    var $templateIdInput = $("#sf-importer__template-id");
    var $statusIdInput = $("#sf-importer__status-id");
    var $importLog = $("#sf-importer__log");
    var $importLogAdded = $("#sf-importer-tab--added");
    var $importLogNotFound = $("#sf-importer-tab--not-found");
    var $importLogAlreadyExists = $("#sf-importer-tab--already-exists");
    var $importLogOtherErrors = $("#sf-importer-tab--other-errors");
    var counter = ".sf-importer-tab--counter";

    // Init jQuery validation
    QLD.forms.init();

    $importBtn.on("click", function (e) {
      e.preventDefault();
      $importForm.valid();

      if ($importForm.valid()) {
        $loader.addClass("loading");
        $importLogAdded.empty();
        $("#sf-importer-tab-heading--added").find(counter).html("0");
        $importLogNotFound.empty();
        $("#sf-importer-tab-heading--not-found").find(counter).html("0");
        $importLogAlreadyExists.empty();
        $("#sf-importer-tab-heading--already-exists").find(counter).html("0");
        $importLogOtherErrors.empty();
        $("#sf-importer-tab-heading--other-errors").find(counter).html("0");

        if ($projectIdInput.val() !== "" && $templateIdInput.val() !== "") {
          sfImporter.getDatastoreData();
          sfImporter.getTemplateData($templateIdInput.val());
        }
      } else {
        console.log("Not valid");
      }
    });
  };

  /**
   * Fetch project data from gathercontent
   *
   * @memberof module:serviceImporter
   */
  sfImporter.buildTemplateStructure = function (data) {
    if (fieldStructure) {
      for (var item of data) {
        var itemLabel = sfImporter.snakeCase(item.label);
        if (item.label === "Major or limited service offering") {
          itemLabel = "facility_level";
        } else if (
          item.label === "Referral Services Directory ID (Admin use)"
        ) {
          itemLabel = "rsd_service_id";
        }
        var itemId = item.uuid;

        for (let field in fieldStructure) {
          if (field === itemLabel) {
            fieldStructure[field] = itemId;
          }
        }
      }
    }
  };

  /**
   * Fetch template data from gathercontent via template_id
   *
   * @memberof module:serviceImporter
   */
  sfImporter.getTemplateData = function (id) {
    var $loader = $(".qld__sf_admin_importer");
    var $projectIdInput = $("#sf-importer__project-id");
    var $templateIdInput = $("#sf-importer__template-id");
    var $statusIdInput = $("#sf-importer__status-id");

    fetch(`https://api.gathercontent.com/templates/${id}`, gatherContentOptions)
      .then((response) => response.json())
      .then((response) => {
        sfImporter.buildTemplateStructure(
          response.related.structure.groups[0].fields,
        );
      })
      .then((response) => {
        sfImporter.getProjectData(
          $projectIdInput.val(),
          $templateIdInput.val(),
          $statusIdInput.val(),
        );
      })
      .catch((err) => {
        $loader.removeClass("loading");
        $("#sf-importer__form-errors").html(
          `<p class="text-error">Template ID is invalid. ${err}</p>`,
        );
      });
  };

  /**
   * Fetch project data from gathercontent
   *
   * @memberof module:serviceImporter
   */
  sfImporter.getProjectData = function (id, templateId, statusId) {
    var $loader = $(".qld__sf_admin_importer");
    var $importLog = $("#sf-importer__log");

    fetch(
      `https://api.gathercontent.com/projects/${id}/items?template_id=${templateId}&status_id=${statusId}`,
      gatherContentOptions,
    )
      .then((response) => response.json())
      .then((response) => {
        $("#sf-importer__form-errors").empty();
        sfImporter.getServiceLocationItems(response.data);
      })
      .then((response) => {
        setTimeout(function () {
          $importLog.fadeIn("slow");
          $loader.removeClass("loading");
        }, 4000);
      })
      .catch((err) => {
        $loader.removeClass("loading");
        $("#sf-importer__form-errors").html(
          `<p class="text-error">Project ID is invalid. ${err}</p>`,
        );
      });
  };

  /**
   * Fetch item data from gathercontent
   *
   * @memberof module:serviceImporter
   */
  sfImporter.getItemData = function (id) {
    var $loader = $(".qld__sf_admin_importer");

    fetch(`https://api.gathercontent.com/items/${id}`, gatherContentOptions)
      .then((response) => response.json())
      .then((response) => {
        sfImporter.checkIfImportable(response.data);
      })
      .catch((err) =>
        sfImporter.report(
          `Failed to import because: ${JSON.stringify(err)}`,
          "Other errors",
          "error",
        ),
      );
  };

  /**
   * Get Service Locations, Facilities and Services from Datastore.
   *
   * @memberof module:serviceImporter
   */
  sfImporter.getDatastoreData = function () {
    fetch(`${serviceFinderData.baseURL}/service-locations`)
      .then((response) => response.json())
      .then((response) => {
        dsServiceLocationData = response;

        return fetch(`${serviceFinderData.baseURL}/services`);
      })
      .then((response) => response.json())
      .then((response) => {
        dsServiceData = response;

        return fetch(`${serviceFinderData.baseURL}/facilities`);
      })
      .then((response) => response.json())
      .then((response) => {
        dsFacilityData = response;
      })
      .catch((err) => console.error(err));
  };

  /**
   * Get service location from item data
   *
   * @memberof module:serviceImporter
   */
  sfImporter.getServiceLocationItems = function (data) {
    var listData = data;

    for (var [i, item] of listData.entries()) {
      sfImporter.getItemData(item.id);
    }
  };

  /**
   * Import service location from item data
   *
   * @memberof module:serviceImporter
   */
  sfImporter.importServiceLocation = function (
    serviceLocationData,
    serviceData,
    facilityData,
  ) {
    var $loader = $(".qld__sf_admin_importer");
    console.log(serviceLocationData);

    var facilityLevel_UUID = fieldStructure.facility_level;
    var rsdServiceId_UUID = fieldStructure.rsd_service_id;
    var description_UUID = fieldStructure.service_description;
    var content_UUID = [
      fieldStructure.content,
      fieldStructure.services_content,
      fieldStructure.how_to_access_this_service,
    ];
    var status_UUID = fieldStructure.status;
    var building_UUID = fieldStructure.building;
    var streetAddress_UUID = fieldStructure.street_address;
    var suburb_UUID = fieldStructure.suburb;
    var postcode_UUID = fieldStructure.postcode;
    var latitude_UUID = fieldStructure.latitude;
    var longitude_UUID = fieldStructure.longitude;
    var contactLabel_UUID = fieldStructure.contact_label_type;
    var secondaryContactLabel_UUID = fieldStructure.secondary_contact_label;
    var primaryPhoneNumber_UUID = fieldStructure.primary_phone_number;
    var secondaryPhoneNumber_UUID = fieldStructure.secondary_phone_number;
    var openingHours_UUID = fieldStructure.opening_hours;

    var serviceLocationContent = ``;

    for (let item in content_UUID) {
      if (content_UUID[item]) {
        serviceLocationContent +=
          serviceLocationData.content[content_UUID[item]];
      }
    }

    console.log(facilityData);

    // This isn't working for some reason, returns null even though the same function call works in the browser console.
    //var updatedBy = serviceFinderData.jwt.getPayload().fullName ? serviceFinderData.jwt.getPayload().fullName : '';

    var serviceLocation = {
      name: serviceLocationData.name,
      web_path: QLD.adminForm.kebabFormat(serviceLocationData.name),
      service_id: serviceData.id,
      facility_id: facilityData.id,
      facility_level: "",
      rsd_service_id: serviceLocationData.content[rsdServiceId_UUID]
        ? serviceLocationData.content[rsdServiceId_UUID].replace(
            /<\/?[^>]+(>|$)/g,
            "",
          )
        : "",
      description: serviceLocationData.content[description_UUID]
        ? serviceLocationData.content[description_UUID]
        : "",
      content: serviceLocationContent,
      status: serviceLocationData.content[status_UUID].label
        ? serviceLocationData.content[status_UUID].label.toLowerCase()
        : "active",
      building: serviceLocationData.content[building_UUID]
        ? serviceLocationData.content[building_UUID].replace(
            /(<([^>]+)>)/gi,
            "",
          )
        : "",
      physical_address_street: facilityData.physical_address_street
        ? facilityData.physical_address_street.replace(/(<([^>]+)>)/gi, "")
        : "",
      physical_address_suburb: facilityData.physical_address_suburb
        ? facilityData.physical_address_suburb.replace(/(<([^>]+)>)/gi, "")
        : "",
      physical_address_postcode: facilityData.physical_address_postcode
        ? facilityData.physical_address_postcode.replace(/(<([^>]+)>)/gi, "")
        : "",
      location_details: facilityData.location_details
        ? facilityData.location_details
        : "",
      latitude: facilityData.latitude
        ? parseFloat(facilityData.latitude)
        : null,
      longitude: facilityData.longitude
        ? parseFloat(facilityData.longitude)
        : null,
      contact_label:
        serviceLocationData.content[contactLabel_UUID].length > 0
          ? serviceLocationData.content[contactLabel_UUID][0].label
          : "",
      phone_number: facilityData.phone_number
        ? facilityData.phone_number.replace(/(<([^>]+)>)/gi, "")
        : "",
      secondary_contact_label:
        serviceLocationData.content[secondaryContactLabel_UUID].length > 0
          ? serviceLocationData.content[secondaryContactLabel_UUID][0].label
          : "",
      secondary_phone_number: serviceLocationData.content[
        secondaryPhoneNumber_UUID
      ]
        ? serviceLocationData.content[secondaryPhoneNumber_UUID]
        : "",
      fax_number: facilityData.fax_number ? facilityData.fax_number : "",
      email_address: facilityData.email_address
        ? facilityData.email_address
        : "",
      opening_hours: serviceLocationData.content[openingHours_UUID]
        ? serviceLocationData.content[openingHours_UUID]
        : "",
      updatedBy: "",
      updatedDate: Date.now(),
    };

    var facilityLevel = serviceLocationData.content[facilityLevel_UUID]
      ? serviceLocationData.content[facilityLevel_UUID][0].label.split(" - ")[0]
      : null;
    var streetAddress = serviceLocationData.content[streetAddress_UUID];
    var suburb = serviceLocationData.content[suburb_UUID];
    var postcode = serviceLocationData.content[postcode_UUID];
    var latitude = serviceLocationData.content[latitude_UUID];
    var longitude = serviceLocationData.content[longitude_UUID];
    var phoneNumber = serviceLocationData.content[primaryPhoneNumber_UUID];

    if (facilityLevel === "Major facility") {
      serviceLocation.facility_level = "major";
    } else if (facilityLevel === "Limited services") {
      serviceLocation.facility_level = "limited";
    } else if (facilityLevel === "Visiting service") {
      serviceLocation.facility_level = "visiting-service";
    } else {
      serviceLocation.facility_level = "";
    }

    if (streetAddress) {
      serviceLocation.physical_address_street = streetAddress.replace(
        /(<([^>]+)>)/gi,
        "",
      );
    }

    if (suburb) {
      serviceLocation.physical_address_suburb = suburb.replace(
        /(<([^>]+)>)/gi,
        "",
      );
    }

    if (postcode) {
      serviceLocation.physical_address_postcode = postcode.replace(
        /(<([^>]+)>)/gi,
        "",
      );
    }

    if (latitude) {
      serviceLocation.latitude = parseFloat(latitude);
    }

    if (longitude) {
      serviceLocation.longitude = parseFloat(longitude);
    }

    if (phoneNumber) {
      serviceLocation.phone_number = phoneNumber.replace(/(<([^>]+)>)/gi, "");
    }

    console.log(serviceLocation);

    serviceFinderData.jwt.getAuthToken();

    serviceFinderData
      .collection("service-locations")
      .add(serviceLocation)
      .then((response) => {
        sfImporter.report(
          `<strong>${serviceLocationData.name} [id#${serviceLocationData.id}]</strong> was successfully imported into Service Locations. <a href="${sfAdminLinks.view}?collection=service-locations&document=${response.id}" target="_blank">View Service Location</a>.`,
          "Added",
          "success",
        );
      })
      .catch((error) => {
        sfImporter.report(
          `<strong>${serviceLocationData.name} [id#${serviceLocationData.id}]</strong> failed to import because: ${JSON.stringify(error)}`,
          "Other errors",
          "error",
        );
        $loader.removeClass("loading");
      });
  };

  /**
   * Build service location from item data
   *
   * @memberof module:serviceImporter
   */
  sfImporter.checkIfImportable = function (data) {
    var serviceLocationData = data;
    var serviceLocationName = serviceLocationData.name;
    var serviceName = serviceLocationName.split(" - ")[0];
    var facilityName = serviceLocationName.split(" - ")[1];

    // Check if Service Location already exists in Datastore
    if (
      sfImporter.getItemFromDatastoreByName(
        serviceLocationName,
        dsServiceLocationData,
      )
    ) {
      sfImporter.report(
        `<strong>${serviceLocationName} [id#${serviceLocationData.id}]</strong> is already a Service Location.`,
        "Already exists",
        "info",
      );
    } else {
      // Check if Service exists in Datastore
      if (
        sfImporter.getItemFromDatastoreByName(serviceName, dsServiceData) &&
        sfImporter.getItemFromDatastoreByName(facilityName, dsFacilityData)
      ) {
        // Service Location DOESN'T already exist and Service & Facility BOTH exist - import
        sfImporter.importServiceLocation(
          serviceLocationData,
          sfImporter.getItemFromDatastoreByName(serviceName, dsServiceData),
          sfImporter.getItemFromDatastoreByName(facilityName, dsFacilityData),
        );
      } else {
        if (
          !sfImporter.getItemFromDatastoreByName(serviceName, dsServiceData)
        ) {
          // Log report that service doesn't exist in datastore
          sfImporter.report(
            `Import for <strong>${serviceLocationName} [id#${serviceLocationData.id}]</strong> failed. <strong>${serviceName}</strong> doesn't exist in services.`,
            "Not found",
            "error",
          );
        }

        if (
          !sfImporter.getItemFromDatastoreByName(facilityName, dsFacilityData)
        ) {
          // Log report that facility doesn't exist in datastore
          sfImporter.report(
            `Import for <strong>${serviceLocationName} [id#${serviceLocationData.id}]</strong> failed. <strong>${facilityName}</strong> doesn't exist in facilities.`,
            "Not found",
            "error",
          );
        }
      }
    }
  };

  /**
   * Gets item from Datastore collection by Name
   *
   * @memberof module:serviceImporter
   */
  sfImporter.getItemFromDatastoreByName = function (needle, haystack) {
    // Check if item exists in array/object.
    return haystack.find(function (item) {
      return item.name.toLowerCase() === needle.toLowerCase();
    });
  };

  /**
   * Make string snake_case (used to make string lowercase and replace spaces with underscore)
   *
   * @memberof module:serviceImporter
   */
  sfImporter.snakeCase = function (string) {
    return string
      .replace(/\W+/g, " ")
      .split(/ |\B(?=[A-Z])/)
      .map((word) => word.toLowerCase())
      .join("_");
  };

  /**
   * Build out and display report for import
   *
   * @memberof module:serviceImporter
   */
  sfImporter.report = function (output, outcome, type = "success") {
    var $importLog = $("#sf-importer__log");
    var $importLogAdded = $("#sf-importer-tab--added");
    var $importLogNotFound = $("#sf-importer-tab--not-found");
    var $importLogAlreadyExists = $("#sf-importer-tab--already-exists");
    var $importLogOtherErrors = $("#sf-importer-tab--other-errors");
    var counter = ".sf-importer-tab--counter";

    if (outcome === "Added") {
      $importLogAdded.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--added")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--added").find(counter).html(),
            10,
          ) + 1,
        );
    }

    if (outcome === "Not found") {
      $importLogNotFound.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--not-found")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--not-found").find(counter).html(),
            10,
          ) + 1,
        );
    }

    if (outcome === "Already exists") {
      $importLogAlreadyExists.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--already-exists")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--already-exists").find(counter).html(),
            10,
          ) + 1,
        );
    }

    if (outcome === "Other errors") {
      $importLogOtherErrors.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--other-errors")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--other-errors").find(counter).html(),
            10,
          ) + 1,
        );
    }
  };

  // Assign
  QLD.sfImporter = sfImporter;

  // Init Admin Form
  $(document).ready(function () {
    if ($(".qld__sf_admin_importer").length > 0) {
      // This is initiated in externals/dsComponentLoader.js
      //QLD.sfImporter.init();
    }
  });
})();
